import { render, staticRenderFns } from "./PaperSubmission.vue?vue&type=template&id=5a08b200&"
import script from "./PaperSubmission.vue?vue&type=script&lang=js&"
export * from "./PaperSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports